export enum ConstructedResponseEmit {
  ANSWER,
  STATE,
  CHAR_COUNT,
}
